var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBuilderTopLeft = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99996 10.7002C8.01863 10.7002 8.03329 10.6855 8.03329 10.6668C8.03329 10.6482 8.01863 10.6335 7.99996 10.6335C7.98129 10.6335 7.96663 10.6482 7.96663 10.6668C7.96663 10.6855 7.98129 10.7002 7.99996 10.7002",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99996 5.36667C8.01863 5.36667 8.03329 5.352 8.03329 5.33333C8.03329 5.31467 8.01863 5.3 7.99996 5.3C7.98129 5.3 7.96663 5.31467 7.96663 5.33333C7.96663 5.352 7.98129 5.36667 7.99996 5.36667",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99996 8.03341C8.01863 8.03341 8.03329 8.01875 8.03329 8.00008C8.03329 7.98141 8.01863 7.96675 7.99996 7.96675C7.98129 7.96675 7.96663 7.98141 7.96663 8.00008C7.96663 8.01875 7.98129 8.03341 7.99996 8.03341",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3 8.00008C5.3 8.01875 5.31467 8.03341 5.33333 8.03341C5.352 8.03341 5.36667 8.01875 5.36667 8.00008C5.36667 7.98141 5.352 7.96675 5.33333 7.96675C5.31467 7.96675 5.3 7.98141 5.3 8.00008",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6334 8.00008C10.6334 8.01875 10.648 8.03341 10.6667 8.03341C10.6854 8.03341 10.7 8.01875 10.7 8.00008C10.7 7.98141 10.6854 7.96675 10.6667 7.96675C10.648 7.96675 10.6334 7.98141 10.6334 8.00008",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66671 10.7002C2.68537 10.7002 2.70004 10.6855 2.70004 10.6668C2.70004 10.6482 2.68537 10.6335 2.66671 10.6335C2.64804 10.6335 2.63337 10.6482 2.63337 10.6668C2.63337 10.6855 2.64804 10.7002 2.66671 10.7002",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99996 13.3667C8.01863 13.3667 8.03329 13.352 8.03329 13.3333C8.03329 13.3147 8.01863 13.3 7.99996 13.3C7.98129 13.3 7.96663 13.3147 7.96663 13.3333C7.96663 13.352 7.98129 13.3667 7.99996 13.3667",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3 13.3333C5.3 13.352 5.31467 13.3667 5.33333 13.3667C5.352 13.3667 5.36667 13.352 5.36667 13.3333C5.36667 13.3147 5.352 13.3 5.33333 13.3C5.31467 13.3 5.3 13.3147 5.3 13.3333",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6334 13.3333C10.6334 13.352 10.648 13.3667 10.6667 13.3667C10.6854 13.3667 10.7 13.352 10.7 13.3333C10.7 13.3147 10.6854 13.3 10.6667 13.3C10.648 13.3 10.6334 13.3147 10.6334 13.3333",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66671 13.3667C2.68537 13.3667 2.70004 13.352 2.70004 13.3333C2.70004 13.3147 2.68537 13.3 2.66671 13.3C2.64804 13.3 2.63337 13.3147 2.63337 13.3333C2.63337 13.352 2.64804 13.3667 2.66671 13.3667",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6334 2.66683C10.6334 2.6855 10.648 2.70016 10.6667 2.70016C10.6854 2.70016 10.7 2.6855 10.7 2.66683C10.7 2.64816 10.6854 2.6335 10.6667 2.6335C10.648 2.6335 10.6334 2.64816 10.6334 2.66683",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 7.96675C13.3147 7.96675 13.3 7.98141 13.3 8.00008C13.3 8.01875 13.3147 8.03341 13.3333 8.03341C13.352 8.03341 13.3667 8.01875 13.3667 8.00008C13.3667 7.98141 13.352 7.96675 13.3333 7.96675",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 5.3C13.3147 5.3 13.3 5.31467 13.3 5.33333C13.3 5.352 13.3147 5.36667 13.3333 5.36667C13.352 5.36667 13.3667 5.352 13.3667 5.33333C13.3667 5.31467 13.352 5.3 13.3333 5.3",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 10.6335C13.3147 10.6335 13.3 10.6482 13.3 10.6668C13.3 10.6855 13.3147 10.7002 13.3333 10.7002C13.352 10.7002 13.3667 10.6855 13.3667 10.6668C13.3667 10.6482 13.352 10.6335 13.3333 10.6335",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 2.6333C13.3147 2.6333 13.3 2.64797 13.3 2.66663C13.3 2.6853 13.3147 2.69997 13.3334 2.69997C13.352 2.69997 13.3667 2.6853 13.3667 2.66663C13.3667 2.64797 13.352 2.6333 13.3334 2.6333",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 13.3C13.3147 13.3 13.3 13.3147 13.3 13.3333C13.3 13.352 13.3147 13.3667 13.3333 13.3667C13.352 13.3667 13.3667 13.352 13.3667 13.3333C13.3667 13.3147 13.352 13.3 13.3333 13.3",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M2.71997 8.23989V2.63989",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M2.71997 2.63999H8.31997",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBuilderTopLeft);
export default ForwardRef;